import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PropertiesComponent } from './properties.component';
import { ListViewComponent } from './list-view/list-view.component';
import { GridViewComponent } from './grid-view/grid-view.component';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { LeafletMarkerClusterModule } from '@asymmetrik/ngx-leaflet-markercluster';
import { MobilePropertiesComponent } from './mobile-properties/mobile-properties.component';
import { DesktopPropertiesComponent } from './desktop-properties/desktop-properties.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { TranslateModule } from '@ngx-translate/core';
import { PropertiesRoutingModule } from './properties-routing.module';
import { MapViewComponent } from './map-view/map-view.component';
import { MatButtonModule } from '@angular/material/button';




@NgModule({
    declarations: [
        PropertiesComponent,
        ListViewComponent,
        GridViewComponent,
        MobilePropertiesComponent,
        DesktopPropertiesComponent,
        MapViewComponent
    ],
    imports: [
        CommonModule,
        PropertiesRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        LeafletModule,
        LeafletMarkerClusterModule,
        NgSelectModule,
        NgbPaginationModule,
        NgxSliderModule,
        TranslateModule,
        MatButtonModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PropertiesModule { }
